import React, {useContext} from "react";
import "./Pages.scss";
import { BuildingsContext } from "../../../bContext";

function PageOne() {

  const { switchToEnglish} = useContext(
    BuildingsContext
  );

  return (
    <>
      <div className="speech-bubble">
        <h1>{switchToEnglish === false ? "Witamy!" : "Welcome!"}</h1>
        <p>
        {switchToEnglish === false ?  "Aby zapoznać się z instukcją naszej prezentacji, klikaj w strzałki lewo i prawo." : "To read the instructions of our presentation, click on the arrows: left or right." }
        </p>
        <div className="inner-triangle-right"></div>
      </div>
  
      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </>
  );
}

export default PageOne;
